/**
 * @name manager.api.BusinessProcesses
 *
 */

import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getBusinessProcessCompletedSteps: {
        method: 'GET',
        url: `${BASE_PATH_API}/businessProcess/:businessProcess/completedStep`
    },
    isBusinessProcessComplete: {
        method: 'GET',
        url: `${BASE_PATH_API}/businessProcess/:businessProcess/completion`
    },
    saveBusinessProcessCompletedStep: {
        method: 'POST',
        url: `${BASE_PATH_API}/businessProcess/:businessProcess/completedStep`
    },
    getBusinessProcessCompletionState: {
        method: 'GET',
        url: `${BASE_PATH_API}/businessProcess/:businessProcess/completionState`
    }
};

export function BusinessProcessApi() {
    return createActions(actions);
}
